<div
  class="historical-bottom-sheet"
  *ngIf="bottomSheetRef"
  [appSwipeToClose]="bottomSheetRef"
  [style.background-color]="getDynamicBackgroundColor()"
  [swipeThreshold]="80"
  [swipeZoneHeight]="120"
  [forceSwipeInZone]="true"
>
  <!-- Header del bottom sheet -->
  <div class="sheet-header" [style.background-color]="getDynamicBackgroundColor()">
    <div class="sheet-handle"></div>
    <!-- <button mat-icon-button class="close-button" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>

  <!-- Contenido principal -->
  <div class="sheet-content">
    <!-- Loading State -->
    <div *ngIf="isLoadingResults" class="loading-data">
      <div class="loading-content">
        <mat-spinner diameter="50" [style.color]="getTextColor()"></mat-spinner>
        <h5 class="loading-text" [style.color]="getTextColor()">Buscando eventos de la tarjeta</h5>
        <p class="loading-subtext" [style.color]="getTextColor()">Esto podría demorar un poco. Espere por favor</p>
      </div>
    </div>

    <!-- Content Ready State -->
    <div *ngIf="!isLoadingResults" class="historical-content">
      <!-- Admin Disabled State -->
      <div *ngIf="isDisabledByAdmin" class="error-state">
        <mat-icon class="error-icon" [style.color]="getTextColor()">info</mat-icon>
        <h3 class="error-message" [style.color]="getTextColor()">En este momento no podemos mostrar información</h3>
        <p class="error-submessage" [style.color]="getTextColor()">Favor re-intente más tarde</p>
      </div>

      <!-- Main Content -->
      <div *ngIf="!isDisabledByAdmin" class="main-content">
        <!-- Icon and Message Section -->
        <div class="icon-and-message">
          <div class="icon-section">
            <img class="history-icon" [src]="lastTabSelected === 0 ? 'assets/images/icons/ic_controller.svg' : 'assets/images/icons/ic_tickets.svg'" alt="Icono histórico" />
          </div>
          <div class="message-section">
            <p class="history-message" [style.color]="getTextColor()">
              Aquí puedes ver el historial<br />
              de jugadas y etickets.
            </p>
          </div>
        </div>

        <!-- Card Information -->
        <div class="card-information">
          <address class="card-details" [style.color]="getTextColor()">
            N° TARJETA: {{ formatCreditCardNumber(cardInformation.card.accountNumber.toString()) }}<br />
            <div *ngIf="!eventFailure && cardActiveFrom">Tarjeta activa desde: {{ cardActiveFrom }}</div>
          </address>
        </div>

        <!-- Historical Data Tabs -->
        <div *ngIf="!eventFailure" class="historical-tabs">
          <mat-tab-group mat-align-tabs="space-between" [selectedIndex]="lastTabSelected" (selectedIndexChange)="updateTabEvent($event)" class="custom-tabs">
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label" [style.color]="getTextColor()">MIS JUGADAS</span>
              </ng-template>
              <div class="tab-content">
                <app-movement-history-table [dataSource]="sourceGames" [tabPosition]="lastTabSelected"> </app-movement-history-table>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label" [style.color]="getTextColor()">MIS ETICKETS</span>
              </ng-template>
              <div class="tab-content">
                <app-movement-history-table [dataSource]="sourceETickets" [tabPosition]="lastTabSelected"> </app-movement-history-table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <!-- Error State -->
        <div *ngIf="eventFailure" class="failure-content">
          <mat-icon class="failure-icon">error</mat-icon>
          <h3 class="failure-message" [style.color]="getTextColor()">No podemos mostrar los eventos de esta tarjeta</h3>
          <p class="failure-submessage" [style.color]="getTextColor()">Intente nuevamente más tarde</p>
        </div>
      </div>
    </div>

    <!-- Footer with eyes image -->
    <div class="footer-eyes">
      <img src="assets/images/img/eyes-footer.png" alt="Eyes Footer" class="eyes-footer-img" />
    </div>
  </div>
</div>

<!-- Template alternativo sin directive para casos donde bottomSheetRef es null -->
<div class="historical-bottom-sheet" *ngIf="!bottomSheetRef" [style.background-color]="getDynamicBackgroundColor()">
  <!-- Header del bottom sheet -->
  <div class="sheet-header">
    <div class="sheet-handle"></div>
    <button mat-icon-button class="close-button" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Contenido principal (igual que arriba pero sin directiva) -->
  <div class="sheet-content">
    <!-- Loading State -->
    <div *ngIf="isLoadingResults" class="loading-data">
      <div class="loading-content">
        <mat-spinner diameter="50" [style.color]="getTextColor()"></mat-spinner>
        <h5 class="loading-text" [style.color]="getTextColor()">Buscando eventos de la tarjeta</h5>
        <p class="loading-subtext" [style.color]="getTextColor()">Esto podría demorar un poco. Espere por favor</p>
      </div>
    </div>

    <!-- Content Ready State -->
    <div *ngIf="!isLoadingResults" class="historical-content">
      <!-- Admin Disabled State -->
      <div *ngIf="isDisabledByAdmin" class="error-state">
        <mat-icon class="error-icon" [style.color]="getTextColor()">info</mat-icon>
        <h3 class="error-message" [style.color]="getTextColor()">En este momento no podemos mostrar información</h3>
        <p class="error-submessage" [style.color]="getTextColor()">Favor re-intente más tarde</p>
      </div>

      <!-- Main Content -->
      <div *ngIf="!isDisabledByAdmin" class="main-content">
        <!-- Icon and Message Section -->
        <div class="icon-and-message">
          <div class="icon-section">
            <img
              class="history-icon"
              [class]="'history-icon ' + getIconFilterClass()"
              [src]="lastTabSelected === 0 ? 'assets/images/icons/ic_controller.svg' : 'assets/images/icons/ic_tickets.svg'"
              alt="Icono histórico"
            />
          </div>
          <div class="message-section">
            <p class="history-message" [style.color]="getTextColor()">
              Aquí puedes ver el historial<br />
              de jugadas y etickets.
            </p>
          </div>
        </div>

        <!-- Card Information -->
        <div class="card-information">
          <address class="card-details" [style.color]="getTextColor()">
            N° TARJETA: {{ formatCreditCardNumber(cardInformation.card.accountNumber.toString()) }}<br />
            <div *ngIf="!eventFailure && cardActiveFrom">Tarjeta activa desde: {{ cardActiveFrom }}</div>
          </address>
        </div>

        <!-- Historical Data Tabs -->
        <div *ngIf="!eventFailure" class="historical-tabs">
          <mat-tab-group mat-align-tabs="space-between" [selectedIndex]="lastTabSelected" (selectedIndexChange)="updateTabEvent($event)" class="custom-tabs">
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label" [style.color]="getTextColor()">MIS JUGADAS</span>
              </ng-template>
              <div class="tab-content">
                <app-movement-history-table [dataSource]="sourceGames" [tabPosition]="lastTabSelected"> </app-movement-history-table>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label" [style.color]="getTextColor()">MIS ETICKETS</span>
              </ng-template>
              <div class="tab-content">
                <app-movement-history-table [dataSource]="sourceETickets" [tabPosition]="lastTabSelected"> </app-movement-history-table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <!-- Error State -->
        <div *ngIf="eventFailure" class="failure-content">
          <mat-icon class="failure-icon">error</mat-icon>
          <h3 class="failure-message" [style.color]="getTextColor()">No podemos mostrar los eventos de esta tarjeta</h3>
          <p class="failure-submessage" [style.color]="getTextColor()">Intente nuevamente más tarde</p>
        </div>
      </div>
    </div>

    <!-- Footer with eyes image -->
    <div class="footer-eyes">
      <img src="assets/images/img/eyes-footer.png" alt="Eyes Footer" class="eyes-footer-img" />
    </div>
  </div>
</div>
